// extracted by mini-css-extract-plugin
export var chatHtmlText = "_om-2";
export var chatLink = "_om-0";
export var chatText = "_om-1";